import { SCREEN_PRESENTER, UNASSIGNED } from '@shoflo/polymer';
import { toggleProgramSource } from '@shoflo/studio-redux/actions';
import { disableAttendeeScreenShare } from '../attendees';
import setSourceAsUnassigned from './setSourceAsUnassigned';
import { setProgram } from 'actions/Broadcast';

/**
 * @param {Object} source - The screen share source to clean up
 * @returns {Function}
 */
function cleanupScreenShare(source) {
  if (
    !source ||
    source.type !== SCREEN_PRESENTER ||
    source.value === UNASSIGNED
  ) {
    return () => {};
  }

  return (dispatch, getState) => {
    dispatch(disableAttendeeScreenShare(source));

    const { program } = getState();
    if (program) {
      const isInProgram = program.layers?.some(
        layer => layer?.source._id === source._id
      );
      if (isInProgram) {
        dispatch(toggleProgramSource(source, setProgram));
      }
    }

    dispatch(setSourceAsUnassigned(source._id));
  };
}

export default cleanupScreenShare;
